// 3_pages/kariera.js
// Careers page (/kariera/, body.in-kariera). Layout is HTML + SCSS.

export function init() {
	if (!document.body.classList.contains("in-kariera")) return;
}
